import { createContext, useContext } from "react";

// Workflow editing actions exposed by the WorkflowTab to deeply-nested React
// Flow node components (TriggerNode, ActionNode, BranchNode). Replaces v1
// window.__appendActionToTrigger / __replaceActionAt singletons so multiple
// editor mounts (e.g. future split-pane) don't clobber each other.

// Stable no-op references — consumers can compare against these to detect
// "provider not mounted" and fall back to the legacy window-bridges.
const NOOP_APPEND = () => {};
const NOOP_REPLACE = () => {};
const NOOP_APPEND_ALT = () => {};
const NOOP_APPEND_OUTCOME = () => {};
const NOOP_APPEND_CLICK = () => {};

export const DEFAULT_WORKFLOW_EDIT = {
  appendActionToTrigger: NOOP_APPEND,
  replaceActionAt: NOOP_REPLACE,
  // BranchingQuestion per-alternative bridge. Looks up the alt by id on the
  // owning InteractivePlugin item, then either appends to the existing chain
  // pointed at by alt.targetActionChainId OR materialises a new trigger
  // (chain root) and links the alt to it.
  appendActionToAlternative: NOOP_APPEND_ALT,
  // Graded-item outcome actions (TrueFalse/YesNo/MCQ). Appends an action to
  // item.params.onCorrectActions or onWrongActions. Locator: boxId + itemId +
  // outcome ("correct"|"wrong") + action object.
  appendOutcomeAction: NOOP_APPEND_OUTCOME,
  // Visual-item click actions (VisualImage/VisualLabel). Appends an action to
  // item.params.onClickActions. Locator: boxId + itemId + action object.
  appendClickAction: NOOP_APPEND_CLICK,
};

export const WorkflowEditContext = createContext(DEFAULT_WORKFLOW_EDIT);

export function useWorkflowEdit() {
  return useContext(WorkflowEditContext);
}
